// Function to apply negative margin and padding to a single horizontal-rule section
function applySpacingToHorizontalRule(horizontalRule) {
  const svg = horizontalRule.querySelector('svg');
  if (!svg) return;
  
  // Get the actual rendered height of the SVG (responsive)
  const svgHeight = svg.getBoundingClientRect().height;
  
  // Get the computed padding-top (32px from --spacing-2)
  const paddingTop = parseFloat(window.getComputedStyle(horizontalRule).paddingTop) || 32;
  
  // Total height to account for: SVG height + padding-top
  const totalHeight = svgHeight + paddingTop;
  
  if (svgHeight > 0) {
    // Apply negative top margin to the horizontal-rule container
    // Account for padding-top and subtract 2px adjustment
    horizontalRule.style.marginTop = `-${totalHeight - 2}px`;
    
    // Find the parent section element (Shopify wraps sections)
    const parentSection = horizontalRule.closest('section[id^="shopify-section"]');
    if (parentSection) {
      // Find the previous shopify-section sibling
      let previousSection = parentSection.previousElementSibling;
      while (previousSection && !(previousSection.id && previousSection.id.startsWith('shopify-section'))) {
        previousSection = previousSection.previousElementSibling;
      }
      
      if (previousSection) {
        // Check if the previous section contains a media-slider
        const mediaSlider = previousSection.querySelector('.media-slider');
        // Check if the previous section contains a hotspot-image
        const hotspotImage = previousSection.querySelector('.hotspot-image');
        
        if (mediaSlider) {
          // For media sliders, extend the slides and images to fill the overlap area
          const slides = mediaSlider.querySelectorAll('.media-slider__slide');
          
          slides.forEach(slide => {            
            // Make image fill the extended slide
            const img = slide.querySelector('.media-slider__image');
            if (img) {
              img.style.objectFit = 'cover';
              img.style.objectPosition = 'center top';
            }
          });
        } else if (hotspotImage) {
          // For hotspot-image, extend the crop-canvas containers
          const cropCanvases = hotspotImage.querySelectorAll('.crop-canvas');
          
          cropCanvases.forEach(canvas => {
            // Add padding-bottom to extend the visible area
            canvas.style.paddingBottom = `${totalHeight}px`;
          });
        } else {
          // Fallback for other section types - add padding-bottom
          const firstDiv = previousSection.querySelector('div');
          if (firstDiv) {
            firstDiv.style.paddingBottom = `${totalHeight}px`;
          }
        }
      }
    }
  }
}

// Function to apply spacing to all horizontal-rule sections
function applyHorizontalRuleSpacing() {
  const horizontalRules = document.querySelectorAll('.horizontal-rule');
  horizontalRules.forEach(applySpacingToHorizontalRule);
}

// Wait for DOM and styles to be ready
function initHorizontalRuleSpacing() {
  // Use requestAnimationFrame to ensure styles are applied
  requestAnimationFrame(() => {
    applyHorizontalRuleSpacing();
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHorizontalRuleSpacing);
} else {
  initHorizontalRuleSpacing();
}

// Use ResizeObserver for smooth, efficient resize handling
let rafId = null;
const resizeObserver = new ResizeObserver(entries => {
  // Cancel any pending animation frame
  if (rafId) {
    cancelAnimationFrame(rafId);
  }
  
  // Batch updates using requestAnimationFrame for smooth performance
  rafId = requestAnimationFrame(() => {
    entries.forEach(entry => {
      const svg = entry.target;
      const horizontalRule = svg.closest('.horizontal-rule');
      if (horizontalRule) {
        applySpacingToHorizontalRule(horizontalRule);
      }
    });
    rafId = null;
  });
});

// Observe all SVGs once DOM is ready
function observeHorizontalRules() {
  const horizontalRules = document.querySelectorAll('.horizontal-rule svg');
  horizontalRules.forEach(svg => {
    resizeObserver.observe(svg);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeHorizontalRules);
} else {
  observeHorizontalRules();
}
